(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      dashboard: {
        "dashboardHeader": "Početna strana",
        "addNewWidget1": "Označite",
        "addNewWidget2": "Favorite",
        "pendingPayments": "Nalozi na čekanju",
        "show": "Prikaži",
        "hide": "Sakrij",
        "domesticPaymentBtn1": "Domaći platni",
        "domesticPaymentBtn2": "nalog",
        "transferBtn1": "Prijenos na",
        "transferBtn2": "moj račun",
        "templateBtn1": "Plaćanje iz",
        "templateBtn2": "predloška",
        "quickPaymentTransfer": "Brzo plaćanje ili transfer",
        "domesticPayment": "Kreiraj opći nalog",
        "internalTransfer": "Kreiraj nalog za prijenos",
        "payTemplate": "Plati predložak",
        "searchTemplatesPlaceholder": "Pretraži predloške",
        "showAccounts": "Prikaži još računa",
        "instantLoan": "Brzi kredit",
        "instantLoanDescription": "Da li ste znali da se možete prijaviti za brzi unaprijed odobreni novčani kredit do 10.000,00 RSD",
        "apply": "Info",
        "contact": "Kontaktirajte nas",
        "hypoClub": "Addiko Club",
        "etrade": "E-Trade",
        "branch": "Pronađite poslovnicu",
        "bankTimeline": "Vremenski prikaz Vašeg poslovanja",
        "loadEvents": "Povijest poslovanja/Povijest događaja",
        "noTimelineData": "Za odabrani period nema podataka za prikaz",
        "availableBalance": "Raspoloživo stanje",
        "loanAmount": "Iznos kredita",
        "confirmation": "Potvrda",
        "complaint": "Prigovor",
        "cashLoan": "Blic gotovinski kredit.",
        "approval": "Samo uz osobnu iskaznicu.",
        "info": "INFO",
        "thankYou" : "Hvala Vam",
        "thankYouMessage" : "Za više informacija o ovome, kliknite na baner",
        "tydUnsubscribe": "Ako više ne želite primati direktne marketinške poruke, molimo da nas o tome obavijestite slanjem poruke s tekstom \"Odjava\" putem funkcionalnosti \"Poruke\" unutar glavnog izbornika ili nas nazovite na brojeve telefona 0800 1414 odnosno +385 1 4898111."
        },
      timelineFilter: {
        "placeholder": "Pretraga i filtriranje",
        "all": "Svi",
        "credit": "Uplate",
        "debit": "Isplate",
        "others": "Ostali",
        "amountFrom": "Iznos od",
        "amountTo": "Do",
        "reset": "Poništi",
        "apply": "Primijeni"
      },
      header: {
        "dashboard": "Kontrolna ploča",
        "accounts": "Računi i kartice",
        "payments": "Plaćanja",
        "orders": "Narudžbe",
        "branches": "Poslovnice i bankomati",
        "settings": "Postavke",
        "notificationMessages": "Poruke",
        "notificationMessagesPlaceholder": "Napišite vaš odgovor",
        "notificationMessagesPlaceholderSubject": "Naslov poruke",
        "notificationMessagesUnread": "Nepročitana",
        "notificationMessagesMarkAsRead": "Označi kao pročitanu",
        "notificationMessagesReply": "Odgovori",
        "notificationMessagesSend": "Pošalji",
        "notificationMessagesCancelSend": "Odustani",
        "notificationMessagesViewAll": "Pregled svih poruka",
        "notificationEInvoices": "Novi eRačuni",
        "notificationEInvoicesDueDate": "datum naplate",
        "notificationEInvoicesPay": "Plati",
        "notificationEInvoicesViewAll": "Pregled svih eRačuna",
        "notificationPendingPayments": "Plaćanja u obradi",
        "notificationPendingPaymentsViewAll": "Pregled svih plaćanja",
        "notificationPendingPaymentsDateLabel": "datum",
        "notificationRejectedPayments": "Odbijena plaćanja",
        "notificationRejectedPaymentsViewAll": "Pregled svih plaćanja",
        "notificationRejectedPaymentsDateLabel": "datum",
        "notificationSettingsLangLabel": "Odaberite jezik:",
        "notificationSettingsViewAllLabel": "Otvorite postavke aplikacije",
        "signedInAs": "Prijavljeni korisnik",
        "lastLogin": "Datum zadnje prijave: ",
        "logout": "Odjava",
        "langEn": "Engleski",
        "langHr": "Hrvatski",
        "langSr": "Srpski",
        "langMtr": "Crnogorski",
        "langBa": "Lokalni",
        "langSl": "Slovenački",
        "langDe": "Njemački",
        "langRu": "Ruski",
        "noMessages": "Nema poruka",
        "noeInvoices": "Nema eRačuna",
        "noPendingPayments": "Nema uplata na čekanju",
        "noRejectedPayments": "Nema odbačenih uplata"
      },
      footer: {
        "freeCall": "Besplatni poziv",
        "internationalCall": "Internacionalni poziv",
        "email": "Pošaljite nam e-mail",
        "notificationDepth": "Dubinska analiza",
        "dearClients": "Poštovani,",
        "modalText1": "dozvolite da Vas informiramo o važnosti ažuriranja Vaših osobnih podataka kako bi se poslovni odnos i nadalje uspješno nastavio.",
        "modalText2": "Podaci kao što su broj i datum valjanosti osobnog identifikacijskog dokumenta (osobna iskaznica, putovnica, dozvola boravka u RH) potrebno je ažurirati u Vama najbližoj poslovnici Banke po isteku njihovog datuma važenja, a sve u skladu s čl.7., Općih uvjeta Addiko Bank d.d.",
        "modalText3": "U svrhu ispravne identifikacije te nužnog ažuriranja Vašeg identifikacijskog dokumenta bit ćemo slobodni obavijestiti Vas o navedenom putem dopisa poslanom na kućnu adresu i/ili porukom proslijeđenom kanalima direktnog bankarstva.",
        "regards": "Srdačan pozdrav",
        "closeButton": "Zatvori",
        "version":"Verzija",
        "server":"Server"
      },
      timeline: {
        msgWith: "Message with subject ",
        msgWithout: "message without subject ",
        msgReceived: " was received on ",
        msgSent: " was sent on "
      },
      templateSearch: {
        favorites: "Favoriti",
        templatesList: "Lista predložaka"
      },
      dashboardWidgets: {
        current: "Tekući računi i kartice",
        loan: "Kreditni računi",
        deposit: "Depozitni računi",
        savings: "Štedni računi",
        giro: "Žiro računi",
        addBtn: "Potvrdi"
      },
      dashboardNotification: {
        rejected: "odbijenih naloga",
        einvoice: "neplaćenih eRačuna",
        group: "grupnih naloga za potpisati",
        goBtn: "Idi na plaćanja",
        unsigned: "naloga za potpisati"
      },
      campaignPopUp: {
        checkBoxText: "Ne prikazuj više"
      }
    };

    $translateProvider
      .translations('hr', data);
  }
}());
